import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { SalesStatsDto } from "../../../shared/dtos/sale/SalesStatsDto";

interface SalesWidgetProps {
  data: SalesStatsDto;
}

const SalesWidget: React.FC<SalesWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("SALE");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Sales Today
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "success.main" }}
          >
            {formatCurrency(data.totalSales)}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 2,
            textAlign: "center",
          }}
        >
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Profit
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "secondary.main" }}
            >
              {formatCurrency(data.totalProfit)}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Tax
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "error.main" }}
            >
              {formatCurrency(data.totalTax)}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Discount
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "warning.main" }}
            >
              {formatCurrency(data.totalDiscount)}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};
export default SalesWidget;
